import classNames from 'classnames';
import Avatar from 'components/base/Avatar';
import Badge from 'components/base/Badge';
import { Conversation } from 'data/chat';
import { useChatContext } from 'providers/ChatProvider';
import React, { useMemo } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MARKED_AS_READ } from 'reducers/ChatReducer';
import { putMarkAsRead } from 'services/chatService';

const UserListitem = ({ conversation }: { conversation: Conversation }) => {
  const { currentConversation, chatDispatch } = useChatContext();

  if (!conversation || !conversation.user) {
    return null;
  }

  const lastMessage = useMemo(() => {
    const messages = conversation.messages ?? [];
    return messages.length > 0 ? messages[messages.length - 1] : null;
  }, [conversation.messages]);

/*   const unseenMessageCount = useMemo(() => {
    const messages = conversation.messages ?? [];
    return messages.filter(
      message => message.type === 'received' && !message.readAt
    ).length;
  }, [conversation.messages]); */

  const unseenMessageCount = useMemo(() => {
    const messages = conversation.messages ?? [];
    
    // 🕵️‍♂️ MODO DETECTIVE: Imprimimos el último mensaje para ver su estructura real
    if (messages.length > 0) {
        console.log(`Mensaje de prueba en chat ${conversation.id}:`, messages[messages.length - 1]);
    }

    return messages.filter(message => {
        // 1. ¿Es un mensaje del cliente? (Atrapamos la opción del template o la de tu BD)
        const isInbound = message.type === 'received' || message.direction === 'inbound';
        
        // 2. ¿Está sin leer? (Buscamos readAt nulo, seen falso, o el status 'unread' que recién creamos)
        const isUnread = !message.readAt || message.seen === false || message.status === 'unread';

        return isInbound && isUnread;
    }).length;
  }, [conversation.messages]);

const markedAsRead = async () => {

  console.log(`🖱️ CLIC DETECTADO en la conversación: ${conversation.id}. Mensajes sin leer: ${unseenMessageCount}`);
    // 🚀 1. OPTIMIZACIÓN: Si ya leíste todo, no molestamos al servidor de Node
    if (unseenMessageCount === 0) return;

    try {
      console.log(`📡 Enviando orden al backend para leer chat: ${conversation.id}`);
      
      // 2. Actualiza la DB
      await putMarkAsRead(String(conversation.id));
      
      console.log(`✅ El backend confirmó la lectura del chat: ${conversation.id}`);

      // 3. Actualiza el estado local
      chatDispatch({
        type: MARKED_AS_READ,
        payload: { conversationId: conversation.id }
      });

    } catch (error) {
      // 🚨 Si falla, ahora lo veremos en rojo brillante en la consola
      console.error(`❌ Falla al marcar como leído el chat ${conversation.id}:`, error);
    }
  };

  return (
    <Nav.Item
      key={conversation.id}
      className={unseenMessageCount > 0 ? 'read' : 'unread'}
    >
      <Nav.Link
        as={Link}
        to={`/app/apps/chat/${conversation.id}/conversation`}
        onClick={markedAsRead}
        className={classNames(
          'd-flex align-items-center justify-content-center p-2',
          {
            unread: unseenMessageCount > 0,
            active: String(currentConversation?.id) === String(conversation.id)
          }
        )}
      >
        <div className="position-relative me-2 me-sm-0 me-xl-2">
          <Avatar
            src={conversation.user.avatar}
            size="xl"
            className="d-block"
            imageClassName="border border-2 border-light-subtle"
          />
          {unseenMessageCount > 0 && (
            <span
              className="bg-primary rounded-circle top-0 end-0 position-absolute text-white d-flex flex-center fs-10 fw-semibold d-none d-sm-flex d-xl-none lh-1"
              style={{ height: '1rem', width: '1rem' }}
            >
              {unseenMessageCount}
            </span>
          )}
        </div>
        <div className="flex-1 d-sm-none d-xl-block">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="text-body fw-normal name text-nowrap">
              {conversation.user.name || conversation.user.nombreCompleto}
            </h5>
            <p className="fs-10 text-body-tertiary text-opacity-85 mb-0 text-nowrap">
              {lastMessage?.time}
            </p>
          </div>
          <div className="d-flex justify-content-between">
            <p className="fs-9 mb-0 line-clamp-1 text-body-tertiary text-opacity-85 message">
              {lastMessage?.message}
            </p>
            {unseenMessageCount > 0 && (
              <Badge
                variant="phoenix"
                bg="primary"
                className="px-1 unread-badge ms-1"
              >
                {unseenMessageCount}
              </Badge>
            )}
          </div>
        </div>
      </Nav.Link>
    </Nav.Item>
  );
};

const UserList = ({ conversations = [] }: { conversations: Conversation[] }) => {
  return (
    <div className="scrollbar">
      <Nav className="chat-conversation-tab flex-column">
        {conversations && conversations.length > 0 ? (
          conversations.map(conversation => (
            <UserListitem 
              conversation={conversation} 
              key={conversation.id || Math.random()} 
            />
          ))
        ) : (
          <p className="text-center mt-3 fs-9 text-body-tertiary">No hay conversaciones</p>
        )}
      </Nav>
    </div>
  );
};

export default UserList;